<div class="discount-wrapper">
    <div class="discount" *ngFor="let benefit of benefits">
        <a title="" class="benfit-link" (click)="benefitClick(benefit)">
            <h1 aria-level="3" role="heading">{{benefit.title}}</h1>
            <span class="discount-text">{{benefit.discountPercent}}% הנחה במעמד החיוב </span>
            <span class="adress" *ngIf="benefit.businessAddress">{{benefit.businessAddress}}</span>
        </a>
    </div>
</div>